<template>
  <home></home>
</template>

<script>
import Home from "./_components/home.vue";
import store from "./_store";

/**
 * @module ManageReview
 * @description manage review module
 */
export default {
  /**
   * @memberof module:ManageReview
   * @namespace components
   * @description components of manage review module
   */
  components: {
    Home,
  },
  created() {
    const STORE_KEY = "$_manage_reviews";

    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  },
};
</script>
